Ext.define('SA.VectorMapGeoJsonSourceDataUrls', {
    singleton: true,

    forMask(data) {
        return this.get('data/map/location/mask', data);
    },

    forPoints(data) {
        return this.get('data/map/location/point', data);
    },

    forPolygons(data) {
        return this.get('data/map/location/polygon', data);
    },

    get(resource, data) {
        var v = encodeURIComponent('get'),
            r = encodeURIComponent(resource),
            d = encodeURIComponent(JSON.stringify(data)),
            f = encodeURIComponent('application/geo+json');

        return `${location.protocol}//${location.host}/dispatch.php?v=${v}&r=${r}&d=${d}&f=${f}`;
    }
});